import React from "react";
import { ShieldCheck, Car, HeartPulse, Factory, ShoppingCart, Cpu, Megaphone, Rocket } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { industries } from "../mock";

const iconMap = { ShieldCheck, Car, HeartPulse, Factory, ShoppingCart, Cpu, Megaphone, Rocket };

const Industries = () => {
  const navigate = useNavigate();
  return (
    <section className="relative bg-[#071d3f] py-24 lg:py-32 overflow-hidden" data-testid="industries-section">
      <div className="absolute -left-40 top-1/3 w-[600px] h-[600px] rounded-full border border-white/8" />
      <div className="absolute -left-20 top-1/4 w-[420px] h-[420px] rounded-full border border-blue-400/10" />
      <div className="absolute left-24 bottom-16 w-3 h-3 rounded-full bg-white/40" />
      <div className="absolute left-64 top-24 w-2 h-2 rounded-full bg-blue-400/30" />

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-[1fr_1.4fr] gap-14 items-center">
        <div className="reveal">
          <p className="text-white text-sm font-semibold tracking-[0.16em] uppercase mb-3">Solutions Across Sectors</p>
          <h2 className="text-white text-5xl lg:text-6xl font-bold leading-[1.05]" style={{ fontFamily: "Archivo, sans-serif" }}>
            Industry<br />Reach
          </h2>
          <p className="text-white/60 mt-6 max-w-sm leading-relaxed">
            Deep domain expertise across the sectors that power India's economy — from banking floors to factory floors.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
          {industries.map((ind, idx) => {
            const Icon = iconMap[ind.icon];
            return (
              <button
                key={ind.slug}
                onClick={() => navigate(`/industries/${ind.slug}`)}
                className="group bg-[#0a2b55] border border-white/5 hover:border-white/40 rounded-2xl p-6 lg:p-7 flex flex-col items-center text-center gap-4 transition-all duration-300 hover:-translate-y-1 hover:bg-[#0c3163] reveal"
                style={{ transitionDelay: `${(idx % 3) * 70}ms` }}
                data-testid={`industry-card-${ind.slug}`}
              >
                <span className="w-14 h-14 rounded-2xl bg-white/12 flex items-center justify-center group-hover:bg-white/22 transition-colors">
                  <Icon size={28} className="text-white" strokeWidth={1.6} />
                </span>
                <span className="text-white font-semibold text-[15px] leading-snug">{ind.name}</span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Industries;
